// dev: https://dev.trgatestore.com/api
// master: https://api.trgatestore.com/api
// home: https://apihome.trgatestore.com/api

let apiUrl = localStorage.getItem("apiUrl");
if (!apiUrl) {
  // localStorage.setItem("apiUrl", "https://api.trgatestore.com/api");
  localStorage.setItem("apiUrl", "https://localhost:5001/api");
  // localStorage.setItem("apiUrl", "https://dev.trgatestore.com/api");
  apiUrl = localStorage.getItem("apiUrl");
}

export const environment = {
  production: false,
  appVersion: "v1.0.0",
  USERDATA_KEY: "tr-gate",
  isMockEnabled: true,
  apiUrl: apiUrl,
};
